/**
 * 全域影片 `assets/video/`（`admin.release_manifest` 權限）。
 *
 * 固定插槽，不是自由的檔案樹——路徑寫死在 `roiN.txt` 的 avatars 區塊裡。前端只負責
 * 「這一格放哪個素材」，路徑、檔名與格式限制都由後端決定。
 */

import { apiFetch, type Schemas } from './core';

export type DisplayGlobalMediaEntry = Schemas['GlobalMediaEntryDto'];

/**
 * 網址上代表「不分語系」的那一段。
 *
 * 資料層是空字串，但空字串放進網址會變成尾斜線而對不上路由（後端同樣用 `-`）。
 */
const NO_LOCALE = '-';

function localeSegment(locale: string): string {
  return locale === '' ? NO_LOCALE : locale;
}

export function listDisplayGlobalMedia(): Promise<DisplayGlobalMediaEntry[]> {
  return apiFetch<DisplayGlobalMediaEntry[]>('/admin/display-global-media', { method: 'GET' });
}

export function setDisplayGlobalMedia(
  slot: string,
  locale: string,
  mediaId: string,
): Promise<DisplayGlobalMediaEntry[]> {
  return apiFetch<DisplayGlobalMediaEntry[]>(
    `/admin/display-global-media/${slot}/${localeSegment(locale)}`,
    { method: 'PUT', body: { media_id: mediaId } },
  );
}

export function clearDisplayGlobalMedia(
  slot: string,
  locale: string,
): Promise<DisplayGlobalMediaEntry[]> {
  return apiFetch<DisplayGlobalMediaEntry[]>(
    `/admin/display-global-media/${slot}/${localeSegment(locale)}`,
    { method: 'DELETE' },
  );
}
